import axiosClient from "api/axiosInstance";
import { Fee, FeeRequest } from "api/models/Fee";

export const getFees = async (): Promise<Fee[]> => {
  const client = axiosClient();

  const response = await client.get(`/elering/admin-costs/all`);

  return response.data.data;
};

export const createFee = async (data: FeeRequest): Promise<Fee> => {
  const client = axiosClient();

  const response = await client.post(`/elering/admin-costs`, { costs: [data] });

  return response.data.data[0];
};

export const updateFee = async (
  feeId: number,
  data: FeeRequest,
): Promise<Fee> => {
  const client = axiosClient();

  const response = await client.put(`/elering/admin-costs/${feeId}`, data);

  return response.data.data;
};

export const deleteFee = async (feeId: number): Promise<void> => {
  const client = axiosClient();

  await client.delete(`/elering/admin-costs/${feeId}`);
};
